import { Directive, ElementRef, Input } from '@angular/core';
import {ScrollbarService } from '../services/scrollbar.service';
import { WindowService} from '../services/window.service';
import {ManageVisibility} from '../models/manage-visibility.class';
import { ParallaxConfig } from '../models/cbj-scroll.models';
export class CbjParallaxDirective extends ManageVisibility {
  config: ParallaxConfig;
/**
 * @param {?} el
 * @param {?} scroll
 * @param {?} window
 */
constructor(public el: ElementRef,
public scroll: ScrollbarService,
public window: WindowService) {
    super(el, scroll, window);
  }
/**
 * @return {?}
 */
ngOnInit() {
    const /** @type {?} */ DEFAULTS = {
      startPosition: 0,
      ratio: .5,
      cssUnit: 'px',
      maxValue: 0,
      minValue: 0
    };
    this.config = {
      ...DEFAULTS,
      ...this.config,
    };
    super.ngOnInit();
  }
/**
 * check for visibility of element
 * @return {?}
 */
manageVisibility(): void {
    const /** @type {?} */ winHeight = this.window.height;

    const /** @type {?} */ scrollTrigger = this.offsetTop - winHeight;

    if (!this.eivVisible && this.scroll.scrollPos >= scrollTrigger) {
      this.eivVisible = true;

    }

    if (this.eivVisible) {
      let /** @type {?} */ resultVal: string;
      let /** @type {?} */ calcVal: number;

      calcVal = ((this.scroll.scrollPos * this.config.ratio) + this.config.startPosition) *  -1;

      if (this.config.maxValue && calcVal >= this.config.maxValue) {
        calcVal = this.config.maxValue;
      } else if (this.config.minValue && calcVal <= this.config.minValue) {
        calcVal = this.config.minValue;
      }

      // added after realizing original setup wasn't compatible in Firefox
      // debugger;
      resultVal = 'center calc(50% + ' + calcVal + this.config.cssUnit + ')';

      this.el.nativeElement.style['backgroundPosition'] = resultVal;
    }

    if (this.eivVisible && this.scroll.scrollPos < scrollTrigger) {
      this.eivVisible = false;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[cbjParallax]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ScrollbarService, },
{type: WindowService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'config': [{ type: Input, args: ['cbjParallax', ] },],
};
}

function CbjParallaxDirective_tsickle_Closure_declarations() {
/** @type {?} */
CbjParallaxDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjParallaxDirective.ctorParameters;
/** @type {?} */
CbjParallaxDirective.propDecorators;
/** @type {?} */
CbjParallaxDirective.prototype.config;
/** @type {?} */
CbjParallaxDirective.prototype.el;
/** @type {?} */
CbjParallaxDirective.prototype.scroll;
/** @type {?} */
CbjParallaxDirective.prototype.window;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
